import * as tslib_1 from "tslib";
var PitActivityDonor_1;
import { jsonMember, jsonObject } from "typedjson";
/** Мероприятие «донор» */
let PitActivityDonor = PitActivityDonor_1 = class PitActivityDonor {
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get code() {
        return this._code;
    }
    set code(value) {
        this._code = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get shortName() {
        return this._shortName;
    }
    set shortName(value) {
        this._shortName = value;
    }
    get curatorId() {
        return this._curatorId;
    }
    set curatorId(value) {
        this._curatorId = value;
    }
    static from(activity) {
        let result = new PitActivityDonor_1();
        result.id = activity.id;
        result.code = activity.code;
        //result.curatorId = ??
        result.name = activity.name;
        result.shortName = activity.shortName;
        return result;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityDonor.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "curatorId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityDonor.prototype, "_curatorId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "code", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityDonor.prototype, "_code", void 0);
tslib_1.__decorate([
    jsonMember({ name: "name", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityDonor.prototype, "_name", void 0);
tslib_1.__decorate([
    jsonMember({ name: "shortName", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityDonor.prototype, "_shortName", void 0);
PitActivityDonor = PitActivityDonor_1 = tslib_1.__decorate([
    jsonObject
], PitActivityDonor);
export { PitActivityDonor };
